import { render, staticRenderFns } from "./Webinari.vue?vue&type=template&id=8f609fe2&scoped=true&"
import script from "./Webinari.vue?vue&type=script&lang=js&"
export * from "./Webinari.vue?vue&type=script&lang=js&"
import style0 from "./Webinari.vue?vue&type=style&index=0&id=8f609fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f609fe2",
  null
  
)

export default component.exports